import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axios } from 'Lib/axios'
import { PARAMS_COOKIE_KEYS } from 'Consts/cookies.enum'
import { CookieHelper } from 'Utils/cookieHelper'

import { useUserStore } from 'Stores/userStoreModuleFed'
import { CouponType } from '../components/Coupon/Coupon'

type AddSubscriptionParams = {
  token?: string
  packageIds: Array<number>
  country?: string
  state?: string
  coupon?: CouponType | { code: string }
  forceNoCc?: boolean
  pricingEndOfTrial?: boolean
  reactivation?: boolean
  reactivationSameProduct?: boolean
}

const AddSubscription = async (body: AddSubscriptionParams) => {
  const accountId = useUserStore.getState().accountId
  const couponCode = body.coupon?.code
  const BodyWithCouponsArray = {
    ...body,
    coupons: couponCode ? [couponCode] : [],
    coupon: undefined,
  }
  return await axios.post<{ data: { subscriptionId: number } }>(
    `accounts/${accountId}/subscriptions`,
    BodyWithCouponsArray
  )
}

export const useAddSubscription = () => {
  const queryClient = useQueryClient()
  const { setSubscription } = useUserStore()
  const { updateLogicCookieData } = CookieHelper()

  const { mutate, isLoading, isError, error } = useMutation(AddSubscription, {
    onSuccess: (res) => {
      setSubscription(res.data.data.subscriptionId)
      updateLogicCookieData(PARAMS_COOKIE_KEYS.SUBSCRIPTION_ID, `${res.data.data.subscriptionId}`)
      void queryClient.invalidateQueries(['getPackagingLimits'])
      void queryClient.invalidateQueries(['accountSettings'])
      void queryClient.invalidateQueries(['userAccounts'])
    },
  })

  return { mutate, isLoading, isError, error }
}
